/*
 * @Author: lqi 575920678@qq.com
 * @Date: 2023-07-24 18:06:44
 * @LastEditors: lqi 575920678@qq.com
 * @LastEditTime: 2025-03-26 15:49:39
 * @FilePath: /msm-title-query/src/APP_CONFIG.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * ❗❗❗❗❗❗❗❗ 如果需要修改api请求地址请 直接修改 SERVER , 请勿修改 APP_CONFIG
 */
export const SERVER: SERVER_TYPE = {
  API_BASE_URL: {
    // development: 'http://192.168.1.10:8085',
    development: 'https://yn-zc.innpst.com',
    production: 'https://yn-zc.innpst.com',
  },
  STATIC_BASE_URL: {
    development: 'https://yn-zc.innpst.com',
    // production: 'https://zcxt.innpst.com',
    production: 'https://zjpt.km12333.cn',
  },
  REPORT_PDF_URL: {
    development: 'https://zjpt.km12333.cn',
    // production: 'https://zcxt.innpst.com',
    production: 'https://zjpt.km12333.cn',
  },
};
const ENV = process.env.NODE_ENV as ENV_TYPE;
const APP_CONFIG: APP_CONFIG_TYPE = {
  // 当前开发环境
  ENV: ENV,
  // 请求地址
  API_BASE_URL: SERVER.API_BASE_URL[ENV],
  // 请求地址【开发】
  DEV_BASE_URL: SERVER.API_BASE_URL.development,
  // 请求地址【生产】
  PROD_BASE_URL: SERVER.API_BASE_URL.production,
  // 静态资源资源
  STATIC_BASE_URL: SERVER.STATIC_BASE_URL[ENV],
  // 静态资源资源【开发】
  DEV_STATIC_URL: SERVER.STATIC_BASE_URL.development,
  // 静态资源资源【生产】
  PROD_STATIC_URL: SERVER.STATIC_BASE_URL.production,
  // 开发环境key
  DEVELOPMENT: 'development',
  // 开发环境key
  PRODUCTION: 'production',
  // debug
  DEBUG: {
    // 是否开启 vconsole
    VCONSOLE: false,
  },
  REPORT_PDF_URL: SERVER.REPORT_PDF_URL[ENV],
  // 开启证书
  SHOW_CERTIFY: false,
};

export const WX_CONFIG: WX_CONFIG_TYPE = {
  appSecret: '414d71cceb4b68d87373026a7b709e10',
  appId: 'wxf61722a75de1010e',
};

export default APP_CONFIG;

// eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6IjgwZmNlMmQ5LWEwZTMtNDNmNC1iMGY1LWJkNGU0YjRjNGRiMCJ9.ROup-6Sm3sFvRVmyp4r0Ny2mN0ajUckPnKDCLraVAAdbLs0S48EweEPgQ_KbVZ2H3ALZYXmikjns7h-MqxKtXw
// 本地测试数据！！！！ 请使用微信开发者工具授权绑定账号获取，
export const LOCAL_DATA = {
  token:
    'eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6ImQ5Mjk4Y2VmLTQ5ODEtNDI5MC05MjA1LWNkN2Y0ZGY3ZmMzYiJ9.xaRl2t5dZ9-RAYhTW0tCuTRPo5IX0OOYPAkzLyfSfzRfc31uwJmNnOjNIHI4d6Tsb5aomKJ8aH3ZHUOduZCY6A',
  openid: 'owrl5wjiGIVzGBj0DrKn2lcO-NK4', // owrl5wjiGIVzGBj0DrKn2lcO-NK4
};
